import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-company-information',
  templateUrl: './company-information.component.html',
})
export class CompanyInformationComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
